import { Box, Button } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseDialog from 'common/components/base-dialog';
import React from 'react';
import { createStyleSheet } from 'utils/helpers';
interface IModalConfirm {
    open: boolean;
    onClose: () => void;
    onOk?: () => void;
    title: string;
    content: React.ReactNode;
    textClose?: string;
    textOk?: string;
}
const ModalConfirm: React.FC<IModalConfirm> = ({
    open,
    onClose,
    onOk,
    title,
    content,
    textClose = 'Đóng',
    textOk = 'Đồng ý',
}) => {
    return (
        <BaseDialog
            open={open}
            onClose={() => onClose()}
            title={title}
            fullWidth={false}
            maxWidth={false}
            sxContent={{
                width: '978px',
                padding: '35px 45px',
                textAlign: 'center',
            }}
        >
            <Box
                sx={{
                    fontSize: '18px',
                    fontWeight: '400',
                    color: common.black,
                }}
            >
                {content}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 1,
                    mt: 5,
                }}
            >
                {textClose && (
                    <Button
                        type="submit"
                        variant="outlined"
                        sx={{
                            ...styles.modalButton,
                            borderWidth: '2px',
                        }}
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {textClose}
                    </Button>
                )}
                {onOk && (
                    <Button
                        type="submit"
                        variant="contained"
                        sx={styles.modalButton}
                        onClick={onOk}
                    >
                        {textOk}
                    </Button>
                )}
            </Box>
        </BaseDialog>
    );
};
const styles = createStyleSheet({
    modalButton: {
        textTransform: 'none',
        borderRadius: '60px',
        minHeight: '60px',
        minWidth: '155px',
        fontSize: '20px',
        fontWeight: '700',
    },
});
export default ModalConfirm;
